import { bool, number, shape, func, object, oneOf, any } from 'prop-types'
import MediaProvider from '../../../MediaProvider'
import ImageBase from '../ImageBase'

const MediaBase = ({
  assetReference,
  autoPlay,
  coverAsset,
  deletable,
  disableCoverAsset,
  disableMediaControls = false,
  downloadable,
  getDuration,
  hasAssetOptions,
  hasAssetOverlay,
  imageFit,
  infoOverlayStyles,
  isHovered,
  onDelete,
  onEmbiggen,
  onRemove,
  overrideStyles,
  placeholder,
  preview,
  readOnly,
  removeable,
  loaded,
  onLoad,
  onError,
  percent,
  thumbnail,
  transforms,
  updateCaption,
  updateCoverAsset,
  videoLoop,
}) => (
  <MediaProvider defaultState={{ isPlaying: autoPlay }}>
    <ImageBase
      assetReference={assetReference}
      autoPlay={autoPlay}
      coverAsset={coverAsset}
      disableCoverAsset={disableCoverAsset}
      deletable={deletable}
      downloadable={downloadable}
      hasAssetOptions={hasAssetOptions}
      hasAssetOverlay={!preview && hasAssetOverlay}
      readOnly={readOnly}
      isHovered={isHovered}
      getDuration={getDuration}
      hasMediaControls={!preview && !disableMediaControls}
      imageFit={imageFit}
      infoOverlayStyles={infoOverlayStyles}
      overrideStyles={overrideStyles}
      onDelete={onDelete}
      updateCaption={updateCaption}
      updateCoverAsset={updateCoverAsset}
      onEmbiggen={onEmbiggen}
      onRemove={onRemove}
      placeholder={placeholder}
      preview={preview}
      removeable={removeable}
      loaded={loaded}
      onLoad={onLoad}
      onError={onError}
      percent={percent}
      thumbnail={thumbnail}
      transforms={transforms}
      videoLoop={videoLoop}
    />
  </MediaProvider>
)

MediaBase.propTypes = {
  assetReference: object,
  autoPlay: bool,
  coverAsset: object,
  deletable: bool,
  disableCoverAsset: bool,
  disableMediaControls: bool,
  downloadable: bool,
  getDuration: func,
  hasAssetOptions: bool,
  hasAssetOverlay: bool,
  imageFit: oneOf(['fill', 'contain', 'cover']),
  infoOverlayStyles: object,
  isHovered: bool,
  loaded: bool,
  readOnly: bool,
  onDelete: func,
  onEmbiggen: func,
  onError: func,
  onLoad: func,
  onRemove: func,
  overrideStyles: shape({
    asset: any,
    assetBase: any,
  }),
  percent: number,
  placeholder: bool,
  preview: bool,
  removeable: bool,
  thumbnail: bool,
  transforms: object,
  updateCaption: func,
  updateCoverAsset: func,
  videoLoop: bool,
}

export default MediaBase
